import { Injectable } from '@angular/core'
import { SweetAlertOptions } from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  async #showToast(icon: 'error' | 'success' | 'warning', message: string, title?: string): Promise<void> {
    const Swal = (await import('sweetalert2')).default

    const toast = Swal.mixin({
      toast: true,
      position: 'bottom',
      showConfirmButton: true,
      confirmButtonText: 'Cerrar',
      buttonsStyling: false,
      customClass: {
        popup: 'shadow-card',
        title: 'preset-body-3! md:preset-body-2!',
        htmlContainer: 'preset-body-4! md:preset-body-3!',
        confirmButton: 'preset-title-4! md:preset-title-3! shadow-button-inset grow cursor-pointer rounded-3xl px-3 py-1 text-white bg-primary-500'
      }
    })

    const params: SweetAlertOptions = { icon }
    if (title) {
      params['title'] = title
      params['text'] = message
    } else {
      params['title'] = message
    }

    await toast.fire(params)
  }

  error(message: string, title?: string) {
    void this.#showToast('error', message, title)
  }

  success(message: string, title?: string) {
    void this.#showToast('success', message, title)
  }

  warning(message: string, title?: string) {
    void this.#showToast('warning', message, title)
  }

  async errorMessage(message: string) {
    const Swal = (await import('sweetalert2')).default
    Swal.fire({ icon: 'error', title: 'Error', text: message, confirmButtonText: 'Cerrar' })
  }

  readonly #confirmBaseOptions = {
    background: '#5563b7',
    color: '#ffffff',
    iconColor: '#f7d72f',
    showCancelButton: true,
    buttonsStyling: false,
    confirmButtonText: 'Sí, reportar',
    cancelButtonText: 'Cancelar',
    width: 'min(480px, calc(100vw - 2rem))',
    customClass: {
      popup: 'rounded-2xl! shadow-card p-6!',
      title: 'preset-title-3!',
      htmlContainer: 'preset-body-2!',
      actions: 'gap-3! mt-4! items-center!',
      confirmButton: 'preset-title-4! shadow-button-inset cursor-pointer rounded-3xl px-6 py-1 m-0! text-primary-900 bg-accent-900',
      cancelButton: 'preset-title-4! shadow-button-inset cursor-pointer rounded-3xl px-6 py-1 m-0! text-white bg-primary-900'
    }
  }

  async confirm(title: string, text?: string): Promise<boolean> {
    const Swal = (await import('sweetalert2')).default
    const result = await Swal.fire({ ...this.#confirmBaseOptions, title, text, icon: 'question' })
    return result.isConfirmed
  }

  async confirmWithInput(title: string, text: string, inputPlaceholder: string): Promise<string | null> {
    const Swal = (await import('sweetalert2')).default
    const result = await Swal.fire({
      ...this.#confirmBaseOptions,
      title,
      text,
      input: 'text',
      inputPlaceholder,
      inputAttributes: {
        autocomplete: 'off',
        style: [
          'border-radius:9999px',
          'border:1px solid rgba(255,255,255,0.3)',
          'padding:8px 16px',
          'margin:8px 0 0 0',
          'background:#fff',
          'color:#000c93',
          'font-size:14px',
          'font-family:"Canva Sans",sans-serif',
          'width:100%',
          'box-sizing:border-box',
          'display:block'
        ].join(';')
      },
      inputValidator: value => (!value?.trim() ? 'Este campo es requerido' : null)
    })
    return result.isConfirmed ? (result.value as string) : null
  }
}
